<template>
    <v-expansion-panels class="expansion">
        <v-expansion-panel>
            <v-expansion-panel-header>
                <div class="expansion__header">
                    <img :src="item.src" width="32px" height="32px">
                    <h3 class="expansion__title">{{ item.title }}</h3>
                    <div class="expansion__show-more">Смотреть</div>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <ul class="expansion__list">
                    <li class="expansion__item" v-for="value in item.values">{{ value }}</li>
                </ul>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    name: "expansionCustom",
    props: {
      colors: Array | Object | String,
    },
    data() {
        return {
            /*item: {
                title: 'Доступные цвета',
                src: '/upload/color.svg',
                values: ['Цвет 1', 'Цвет 2', 'Цвет 3']
            }*/
            item: this.colors,
        }
    }
}
</script>


<style lang="scss">
.expansion {

  .v-expansion-panel::before {
    box-shadow: none;
  }

  .v-expansion-panel-content__wrap {
    padding: 0;
  }

  .v-expansion-panel-header {
    width: 100%;
    padding: 0;
    padding-right: 12px;
  }

  .mdi-chevron-down::before {
    content: '';
    width: 20px;
    height: 20px;
    background: url(/upload/arrow.svg) no-repeat;
    transform: rotate(-180deg) translateY(2px);
  }

  .v-expansion-panel--active > .v-expansion-panel-header--active .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate) .v-icon {
    transform: rotate(-180deg) translateY(7px);
  }
}

</style>

<style lang="scss" scoped>
.expansion {
  padding-top: 10px;
  margin: 0 !important;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;
  }

  &__title {
    font-family: 'RobotoRegular';
    font-weight: 500;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #212424;
    margin: 0;
  }

  &__show-more {
    font-family: 'RobotoRegular';
    font-weight: 500;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: 0px;
    color: #7D7D7D;
    margin-right: 10px;
  }

  &__list {
    border: 1px solid #E1E1E2;
    border-radius: 12px;
    padding: 12px 16px;
    list-style: none;
  }

  &__item {
    font-family: 'RobotoRegular';
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: left;
    color: #1A1A1A;
    margin-bottom: 12px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

}
</style>